<script lang="ts" setup>
import { useAppStore } from '../../stores/app.ts';

const app = useAppStore();
</script>

<template>
    <VFooter app color="secondary">
        <VContainer>
            <p class="text-center">© {{ new Date().getFullYear() }} {{ app.product.name }}. All rights reserved.</p>
        </VContainer>
    </VFooter>
</template>
